// extracted by mini-css-extract-plugin
export default {"textButton":"iGKMQm","textButtonDisabled":"tqhzSa"};